// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3yym5","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1niaT"};